import { styled } from '@mui/material/styles';
import { ReactComponent as Icon } from '@/assets/settings.svg';
import classNames from 'classnames';

export const SettingsIcon = styled(
	({ className }: { className?: string }) => (
		<Icon className={classNames('icon', 'settings', className)} />
	),
	{
		target: 'SettingsIcon-root',
		label: 'SettingsIcon',
	},
)({});
